"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "<span{{#if r}} data-ref-id=\"{{r}}\" style=\"{{highlightClause r}}\"{{/if}}>\n{{~#if value ~}}\n{{ concat value }}\n{{~/if ~}}\n{{~#if s~}}\n{{~#each s~}}\n{{> clause ~}}\n{{~/each ~}}\n{{~/if~}}\n</span>";
//# sourceMappingURL=clause.js.map